<template>
  <div class="mb-3">
    <label class="idx-bold mr-1 mb-3">{{
      $t('newAction.stepOne.labels.additionalQuestion')
    }}</label>
    <span id="popover-target-1">
      <font-awesome-icon
        :icon="['fas', 'info-circle']"
        style="font-size: 15px; color: #c1c1c1"
      />
    </span>

    <b-popover target="popover-target-1" triggers="hover" placement="top">
      <template v-slot:title>{{ $t('newAction.stepOne.metrics') }}</template>
      <span
        >{{ $t('newAction.stepOne.review') }} -
        <font-awesome-icon class="metric-icons" :icon="['fas', 'star']" />
        <font-awesome-icon
          class="metric-icons"
          :icon="['fas', 'star-half']"
        /> </span
      ><br />
      <span>{{ $t('newAction.stepOne.csat0a10') }}</span
      ><br />
      <span>{{ $t('newAction.stepOne.likert1a5') }}</span
      ><br />
      <span
        >{{ $t('newAction.stepOne.likeDislike') }} -
        <font-awesome-icon class="metric-icons" :icon="['fas', 'thumbs-up']" />
        <font-awesome-icon
          class="metric-icons"
          :icon="['fas', 'thumbs-down']"
        /> </span
      ><br />
      <span
        >{{ $t('newAction.stepOne.emotion') }} -
        <font-awesome-icon class="metric-icons" :icon="['fas', 'smile']" />
        <font-awesome-icon
          class="metric-icons"
          :icon="['fas', 'frown']"
        /> </span
      ><br />
      <span>{{ $t('newAction.stepOne.multipleChoices') }}</span
      ><br />
      <span>{{ $t('newAction.stepOne.text') }}</span
      ><br />
      <span>{{ $t('newAction.stepOne.registrationData') }}</span
      ><br />
      <span>NPS</span><br />
    </b-popover>

    <div class="custom-switch float-right">
      <input
        type="checkbox"
        class="custom-control-input"
        id="show-questions"
        v-model="active"
      />
      <label class="custom-control-label" for="show-questions"></label>
    </div>

    <draggable v-model="action.email.additionalQuestions" :disabled="draggable">
      <div
        v-for="(item, index) in action.email.additionalQuestions"
        :key="index"
        class="item-question"
      >
        <font-awesome-icon :icon="['fas', 'ellipsis-v']" class="ellipsis" />
        <div class="form-group">
          <select
            class="form-control addquestions-value"
            v-model="item.type"
            @change="verifyQuestionType(item.type, index)"
          >
            <option value="REVIEWS">
              {{ $t('newAction.stepOne.review') }}
            </option>
            <option value="CSAT">{{ $t('newAction.stepOne.csat') }}</option>
            <option value="LIKERT">{{ $t('newAction.stepOne.likert') }}</option>
            <option value="LIKE/DISLIKE">
              {{ $t('newAction.stepOne.likeDislike') }}
            </option>
            <option value="EMOTION">
              {{ $t('newAction.stepOne.emotion') }}
            </option>
            <option value="MULTIPLE">
              {{ $t('newAction.stepOne.multipleChoices') }}
            </option>
            <option value="LABEL">
              {{ $t('newAction.stepOne.label') }}
            </option>
            <option value="INPUT">Input</option>
            <option value="CONTACT">Contatos</option>
            <option value="CES">CES 1 a 5</option>
            <option value="NPS">NPS</option>
            <option value="LIKERT/EMOTION">Likert/Emotion</option>
            <option v-if="isGNDI" value="INPUT-CPF">Input CPF</option>
          </select>
        </div>
        <div class="question-text">
          <div v-if="action.multiLanguage">
            <input
              type="text"
              class="form-control"
              :placeholder="returnPlaceholder(item)"
              :disabled="action.multiLanguage"
              v-model="item.text"
            />
          </div>
          <div v-else>
            <input
              type="text"
              class="form-control addquestions-value"
              v-model="item.text"
            />
            <div class="invalid-feedback">
              {{ $t('newAction.stepOne.feedbackEnterQuestion') }}
            </div>
          </div>
        </div>

        <button class="btn-gray" v-b-modal="`modal-config-${index}`">
          <font-awesome-icon
            title="Configurar opções"
            :icon="['fas', 'ellipsis-h']"
          />
        </button>
        <button
          v-if="item.type === 'MULTIPLE'"
          class="btn btn-outline-primary"
          v-b-modal="`modal-multiple-${index}`"
          @click="setCheckedOther(index)"
        >
          <font-awesome-icon :icon="['fas', 'edit']" />
        </button>
        <button
          v-if="item.type === 'CONTACT'"
          class="btn btn-outline-primary"
          v-b-modal="`modal-input-contact-${index}`"
        >
          <font-awesome-icon :icon="['fas', 'edit']" />
        </button>
        <button
          class="btn btn-gray"
          title="Configurar regras lógicas"
          v-if="
            item.type !== 'CONTACT' &&
            item.type !== 'INPUT' &&
            item.type !== 'INPUT-CPF' &&
            item.type !== 'LABEL'
          "
          @click="returnValue(item.type, index)"
          v-b-modal="`modal-logical-rules-${index}`"
        >
          <font-awesome-icon :icon="['fas', 'cog']" />
          <template v-if="item.logicalRuleEnabled">
            <span>!</span>
          </template>
        </button>
        <button
          v-if="action.multiLanguage"
          class="btn btn-gray"
          title="Configurar idioma"
          v-b-modal="`modal-translation-${index}`"
        >
          <i style="color: #000" class="far fa-flag"></i>
        </button>
        <button class="btn btn-outline-danger">
          <font-awesome-icon
            :icon="['fas', 'trash-alt']"
            @click="removeQuestion(index)"
          />
        </button>
        <button class="btn btn-outline-primary" @click="addQuestion">
          <font-awesome-icon :icon="['fas', 'plus']" />
        </button>

        <!-- modal contacts -->
        <b-modal
          :id="`modal-input-contact-${index}`"
          title="Opções de coleta de informações cadastrais"
          size="lg"
          ok-only
        >
          <p>Escolha qual tipo de canal deseja coletar de seus clientes</p>
          <div class="row">
            <div class="col-8">
              <input type="text" class="form-control" v-model="item.text" />
            </div>
            <!-- <div class="col-4">
              <select class="form-control">
                <option value="checkbox">Tipo multipla</option>
              </select>
            </div> -->
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <b-form-group>
                <b-form-checkbox-group
                  v-model="selected"
                  :options="options"
                  @change="inputChecked($event, index)"
                ></b-form-checkbox-group>
              </b-form-group>
            </div>

            <div class="col-12">
              <p><strong>Tipo de exibição</strong></p>
              <b-form-group>
                <b-form-radio-group
                  v-model="selectedDisplayType"
                  name="radio-exhibition"
                >
                  <b-form-radio
                    @change="changeExhibition('formSearch', index)"
                    value="formSearch"
                    >No formulário da pesquisa</b-form-radio
                  >
                  <b-form-radio
                    @change="changeExhibition('afterSendAnswer', index)"
                    value="afterSendAnswer"
                    >Após envio da resposta (pop-up)</b-form-radio
                  >
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div>
        </b-modal>

        <!-- modal more config -->
        <b-modal
          :id="`modal-config-${index}`"
          :title="`${$t('actionTranslateUpdate.moreOptionsRules.modalTitle')}`"
          size="lg"
          ok-only
        >
          <div>
            <p>
              {{ $t('actionTranslateUpdate.moreOptionsRules.describe') }}
            </p>

            <div style="padding: 20px">
              <div
                class="custom-switch"
                v-if="action.customMandatoryQuestion && item.type !== 'LABEL'"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  @click="item.mandatory = !item.mandatory"
                  :id="`mandatory-${index}`"
                  v-model="item.mandatory"
                />
                <label class="custom-control-label" :for="`mandatory-${index}`"
                  >Obrigatória</label
                >
                <hr />
              </div>

              <div
                class="custom-switch"
                v-if="
                  item.type !== 'INPUT' &&
                  item.type !== 'INPUT-CPF' &&
                  item.type !== 'MULTIPLE' &&
                  item.type !== 'LABEL' &&
                  item.type !== 'CONTACT'
                "
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="`comment-${index}`"
                  @click="item.commentEnabled = !item.commentEnabled"
                  v-model="item.commentEnabled"
                />
                <label class="custom-control-label" :for="`comment-${index}`">{{
                  $t('actionTranslateUpdate.moreOptionsRules.addNewField')
                }}</label>
                <hr />
              </div>
              <div
                class="custom-switch"
                v-if="
                  action.channel !== 'widget' &&
                  selectedDisplayType !== 'afterSendAnswer'
                "
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="`hide-${index}`"
                  @click="item.display = !item.display"
                  v-model="item.display"
                />
                <label class="custom-control-label" :for="`hide-${index}`">{{
                  $t('actionTranslateUpdate.options.hideDefault')
                }}</label>
                <hr />
              </div>

              <div
                class="custom-switch"
                v-if="
                  item.type !== 'INPUT' &&
                  item.type !== 'INPUT-CPF' &&
                  item.type !== 'MULTIPLE' &&
                  item.type !== 'LABEL' &&
                  item.type !== 'CONTACT'
                "
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  @click="item.applicableEnabled = !item.applicableEnabled"
                  v-model="item.applicableEnabled"
                  :id="`not-apply-${index}`"
                />
                <label
                  class="custom-control-label"
                  :for="`not-apply-${index}`"
                  >{{
                    $t('actionTranslateUpdate.moreOptionsRules.notApply')
                  }}</label
                >
                <hr />
              </div>

              <div
                class="custom-switch"
                v-if="item.type !== 'CONTACT'"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  @click="item.profileEnabled = !item.profileEnabled"
                  v-model="item.profileEnabled"
                  :id="`profile-${index}`"
                />
                <label class="custom-control-label" :for="`profile-${index}`"
                  >{{
                    $t(
                      'actionTranslateUpdate.moreOptionsRules.notApplyDescribe',
                    )
                  }}
                </label>
                <br />
              </div>
              <div v-if="item.type !== 'CONTACT'">
                <b-form-group
                  :label="`${$t(
                    'actionTranslateUpdate.moreOptionsRules.labelText',
                  )}`"
                  v-slot="{ ariaDescribedby }"
                >
                  <b-form-radio-group
                    id="checkbox-group-1"
                    v-model="item.selectedProfile"
                    :options="optionsProfile"
                    :aria-describedby="ariaDescribedby"
                    name="flavour-1"
                  ></b-form-radio-group>
                </b-form-group>
                <hr />
              </div>

              <div
                class="custom-switch"
                v-if="item.type !== 'LABEL' && item.type !== 'CONTACT'"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  @click="
                    item.indicatorValueEnabled = !item.indicatorValueEnabled
                  "
                  v-model="item.indicatorValueEnabled"
                  :id="`indicatorName-${index}`"
                />
                <label
                  class="custom-control-label"
                  style="max-width: 660px"
                  :for="`indicatorName-${index}`"
                  >{{ $t('actionTranslateUpdate.moreOptionsRules.seeAnswer') }}
                </label>
                <br />
                <div style="display: flex">
                  <div class="col-4" style="display: flex">
                    <p>
                      {{
                        $t('actionTranslateUpdate.moreOptionsRules.indicator')
                      }}
                    </p>
                    <b-form-select
                      style="margin-left: 15px; width: 130px"
                      v-model="item.selectedIndicator"
                      :options="optionsIndicator"
                    ></b-form-select>
                  </div>
                  <div class="col-4" style="display: flex">
                    <p>
                      {{
                        $t('actionTranslateUpdate.moreOptionsRules.critrion')
                      }}
                    </p>
                    <b-form-select
                      style="margin-left: 15px; width: 130px"
                      v-model="item.indicatorCriterion"
                      :options="optionsCriterion"
                    ></b-form-select>
                  </div>
                  <div class="col-4" style="display: flex">
                    <p>
                      {{ $t('actionTranslateUpdate.moreOptionsRules.params') }}
                    </p>
                    <input
                      style="margin-left: 15px"
                      type="text"
                      v-model="item.indicatorValue"
                      :id="`indicatorValue-${index}`"
                      class="form-control"
                    />
                  </div>
                  <hr class="m-4" />
                </div>
              </div>
            </div>
          </div>
          <div
            class="row mt-2"
            v-if="action.channel === 'totem' && item.type !== 'CONTACT'"
          >
            <div class="col-12" style="display: flex">
              <p>Posição no agrupamento:</p>
              <input
                type="number"
                v-model="item.group"
                :id="`group-${index}`"
                class="form-control col-1 ml-2"
              />
            </div>
          </div>

          <!-- custom nps template -->
          <div v-if="item.type === 'CSAT' || item.type === 'NPS'" class="m-4">
            <b-form-radio-group v-model="item.template">
              <div class="row mt-2">
                <div class="col-12">
                  <p>Layout da pergunta adicional</p>
                </div>

                <div class="col-6" v-if="item.type === 'CSAT'">
                  <b-form-radio value="outline"
                    >Vazado (padrão)<br />
                    <c-sat
                      :textColor="'#000000'"
                      :text="''"
                      :item-id="'_2'"
                      :index="0"
                      :colorTemplate="null"
                      :commentEnabled="false"
                      :applicableEnabled="false"
                      :addQuestionTemplate="'default'"
                      :idQuestion="''"
                      template="outline"
                    />
                  </b-form-radio>
                </div>

                <div class="col-6" v-if="item.type === 'CSAT'">
                  <b-form-radio value="gradient"
                    >Gradiente <br />
                    <c-sat
                      :textColor="'#000000'"
                      :text="''"
                      :item-id="'_0'"
                      :index="0"
                      :colorTemplate="null"
                      :commentEnabled="false"
                      :applicableEnabled="false"
                      :addQuestionTemplate="'default'"
                      :idQuestion="''"
                      template="gradient"
                    />
                  </b-form-radio>
                </div>

                <div class="col-6" v-if="item.type === 'CSAT'">
                  <b-form-radio value="static"
                    >Estático <br />
                    <c-sat
                      :textColor="'#000000'"
                      :text="''"
                      :item-id="'_1'"
                      :index="1"
                      :colorTemplate="null"
                      :commentEnabled="false"
                      :applicableEnabled="false"
                      :addQuestionTemplate="'default'"
                      :idQuestion="''"
                      template="static"
                    />
                  </b-form-radio>
                </div>

                <div class="col-6" v-if="item.type === 'NPS'">
                  <b-form-radio value="outline"
                    >Vazado (padrão)<br />
                    <nps
                      :textColor="'#000000'"
                      :text="''"
                      :item-id="'_2'"
                      :index="0"
                      :colorTemplate="null"
                      :commentEnabled="false"
                      :applicableEnabled="false"
                      :addQuestionTemplate="'default'"
                      :idQuestion="''"
                      template="outline"
                    />
                  </b-form-radio>
                </div>

                <div class="col-6" v-if="item.type === 'NPS'">
                  <b-form-radio value="gradient"
                    >Gradiente <br />
                    <nps
                      :textColor="'#000000'"
                      :text="''"
                      :item-id="'_0'"
                      :index="0"
                      :colorTemplate="null"
                      :commentEnabled="false"
                      :applicableEnabled="false"
                      :addQuestionTemplate="'default'"
                      :idQuestion="''"
                      template="gradient"
                    />
                  </b-form-radio>
                </div>

                <div class="col-6" v-if="item.type === 'NPS'">
                  <b-form-radio value="static"
                    >Estático <br />
                    <nps
                      :textColor="'#000000'"
                      :text="''"
                      :item-id="'_1'"
                      :index="1"
                      :colorTemplate="null"
                      :commentEnabled="false"
                      :applicableEnabled="false"
                      :addQuestionTemplate="'default'"
                      :idQuestion="''"
                      template="static"
                    />
                  </b-form-radio>
                </div>
              </div>
            </b-form-radio-group>
          </div>

          <div v-if="item.type === 'LIKERT'" class="m-4 likert-options">
            <b-form-group :label="$t('newAction.stepOne.typeQuestionLikert')">
              <b-form-radio-group
                v-model="item.template"
                :value="item.template"
                name="radio-exhibition-likert"
              >
                <b-form-radio value="satisfaction">Satisfação</b-form-radio>
                <b-form-radio value="agreement">Concordância</b-form-radio>
                <b-form-radio value="frequency">Frequência</b-form-radio>
                <b-form-radio value="importance">Importância</b-form-radio>
                <b-form-radio value="probability">Probabilidade</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <p>Visualização de pergunta likert selecionada:</p>
            <likert :template="item.template" :configAction="true" />
          </div>

          <div v-if="item.type === 'MULTIPLE'" class="ml-3">
            <b-form-group label="Layout da pergunta adicional:">
              <b-form-radio-group
                v-model="item.template"
                :value="item.template"
                name="radio-exhibition-multiple"
              >
                <b-form-radio
                  value="default"
                  style="width: 210px; margin-bottom: 10px"
                  >Padrão</b-form-radio
                >
                <b-form-radio
                  value="withSubOptions"
                  style="width: 250px; margin-bottom: 10px"
                  >Sub opções</b-form-radio
                >
              </b-form-radio-group>
              <div style="display: flex">
                <div class="example">
                  <label>Exemplo</label>
                  <b-form-group>
                    <b-form-radio name="some-radios" value="A"
                      >Option A</b-form-radio
                    >
                    <b-form-radio class="mt-2" name="some-radios" value="B"
                      >Option B</b-form-radio
                    >
                  </b-form-group>
                </div>
                <div class="example-multiple-choices">
                  <label>Exemplo</label>
                  <b-form-group style="margin-left: 20px">
                    <b-form-radio-group v-model="selectedRadioChoice">
                      <b-form-radio
                        v-for="(item, index) in exampleListMultiples[0].choices"
                        :value="item"
                        :key="index"
                      >
                        <span class="arrow-toggle">
                          <i
                            v-if="selectedRadioChoice.text === item.text"
                            class="fas fa-caret-down"
                            style="margin-left: -3px"
                          />
                          <i v-else class="fas fa-caret-right" />
                        </span>
                        {{ item.text }}
                        <b-form-radio-group>
                          <template
                            v-if="selectedRadioChoice.text == item.text"
                          >
                            <b-form-radio
                              v-for="(subItem, indexSubItem) in item.subChoices"
                              :value="subItem.textPt"
                              :key="indexSubItem"
                            >
                              {{ subItem }}
                            </b-form-radio>
                          </template>
                        </b-form-radio-group>
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
              </div>
            </b-form-group>
          </div>
        </b-modal>

        <!-- modal multiple choice-->
        <b-modal
          :id="`modal-multiple-${index}`"
          :title="$t('newAction.stepOne.multipleChoiceModal.title')"
          size="lg"
          ok-only
        >
          <p>
            {{ $t('newAction.stepOne.multipleChoiceModal.description') }}
          </p>
          <div class="row">
            <div class="col-8">
              <input
                type="text"
                :disabled="action.multiLanguage"
                class="form-control"
                v-model="item.text"
              />
            </div>
            <div class="col-4">
              <select
                v-model="item.multipleType"
                class="form-control"
                @change="handleMultipleType($event.target.value, index)"
              >
                <option value="radio">
                  {{ $t('newAction.stepOne.multipleChoiceModal.singleChoice') }}
                </option>
                <option value="checkbox">
                  {{
                    $t('newAction.stepOne.multipleChoiceModal.multipleChoice')
                  }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mt-3">
            <div v-if="displayChoices" class="col-12">
              <draggable v-model="action.email.additionalQuestions[index].choices" @change="updateOrderChoices(index, action.email.additionalQuestions[index].choices)">
                <div
                  class="choice"
                  v-for="(choice, i) in action.email.additionalQuestions[index]
                    .choices"
                  :key="i"
                >
                  <template v-if="item.template === 'default' || !item.template">
                   <font-awesome-icon :icon="['fas', 'ellipsis-v']" class="ellipsis mb-2" />
                    <b-form-radio
                      v-if="
                        action.email.additionalQuestions[index].multipleType ===
                        'radio'
                      "
                      name="radio-type"
                    />
                    <b-form-checkbox
                      v-if="
                        action.email.additionalQuestions[index].multipleType ===
                        'checkbox'
                      "
                      name="checkbox-1"
                    />
                    <input
                      type="text"
                      class="choice-text"
                      v-model="choice.text"
                    />

                    <div>
                      <button
                        @click="showSubQuestion(index, i)"
                        class="btn btn-gray"
                        v-if="item.template === 'withSubOptions' && !action.email.additionalQuestions[index].choices[i].isOther"
                      >
                        <font-awesome-icon
                          style="color: #5e5e5e"
                          :icon="['fas', 'folder-plus']"
                        />
                      </button>
                      <button
                        v-if="action.multiLanguage"
                        class="btn btn-gray"
                        title="Configurar idioma"
                        v-b-modal="`modal-multiple-translation-${index}`"
                        @click="
                          openModalTranslation(
                            action.email.additionalQuestions[index],
                            i,
                          )
                        "
                      >
                        <i style="color: #000" class="far fa-flag"></i>
                      </button>
                      <button
                        class="btn btn-outline-danger"
                        @click="removeMultipleChoice(index, i)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                      <button
                        class="btn btn-outline-primary"
                        @click="addMultipleChoice(index)"
                      >
                        <font-awesome-icon :icon="['fas', 'plus']" />
                      </button>
                    </div>
                  </template>
                  <template v-if="item.template === 'withSubOptions'">
                    <div
                      :id="`sub-options-${i}`"
                      style="display: block; width: 100%"
                    >
                      <div class="display-flex">
                        <font-awesome-icon :icon="['fas', 'ellipsis-v']" class="ellipsis-multiple" />
                        <b-form-radio
                          v-if="
                            action.email.additionalQuestions[index]
                              .multipleType === 'radio'
                          "
                          name="radio-type"
                          style="margin-top: 10px"
                        />
                        <b-form-checkbox
                          v-if="
                            action.email.additionalQuestions[index]
                              .multipleType === 'checkbox'
                          "
                          style="margin-top: 10px"
                          name="checkbox-1"
                        />
                        <input
                          type="text"
                          class="choice-text"
                          v-model="choice.text"
                        />
                        <div>
                          <button
                            @click="showSubQuestion(index, i)"
                            class="btn btn-gray"
                            v-if="item.template === 'withSubOptions' && !action.email.additionalQuestions[index].choices[i].isOther"
                          >
                            <font-awesome-icon
                              style="color: #5e5e5e"
                              :icon="['fas', 'folder-plus']"
                            />
                          </button>
                          <button
                            v-if="action.multiLanguage"
                            class="btn btn-gray"
                            title="Configurar idioma"
                            v-b-modal="`modal-multiple-translation-${index}`"
                            @click="
                              openModalTranslation(
                                action.email.additionalQuestions[index],
                                i,
                              )
                            "
                          >
                            <i style="color: #000" class="far fa-flag"></i>
                          </button>
                          <button
                            class="btn btn-outline-danger"
                            @click="removeMultipleChoice(index, i)"
                          >
                            <font-awesome-icon :icon="['fas', 'trash-alt']" />
                          </button>
                          <button
                            class="btn btn-outline-primary"
                            @click="addMultipleChoice(index)"
                          >
                            <font-awesome-icon :icon="['fas', 'plus']" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div
                      :id="`sub-options-accordion-${i}`"
                      class="accordion"
                      role="tablist"
                      style="display: none; width: 100%"
                    >
                      <b-card no-body class="card-accordion-multiple mb-1">
                        <b-card-header
                          header-tag="header"
                          class="card-accordion-multiple p-1"
                          role="tab"
                        >
                          <div class="display-flex">
                            <font-awesome-icon :icon="['fas', 'ellipsis-v']" class="ellipsis-multiple" />
                            <button
                              class="btn-arrow"
                              v-b-toggle="'accordion-modal-' + i"
                            >
                              <i class="fas fa-caret-right icon-arrow-right" />
                            </button>
                            <input
                              type="text"
                              class="choice-text"
                              v-model="choice.text"
                            />
                            <div>
                              <button
                                @click="showSubQuestion(index, i)"
                                class="btn btn-gray"
                                v-if="item.template === 'withSubOptions' && !action.email.additionalQuestions[index].choices[i].isOther"
                                v-b-toggle="'accordion-modal-' + i"
                              >
                                <font-awesome-icon
                                  style="color: #5e5e5e"
                                  :icon="['fas', 'folder-plus']"
                                />
                              </button>
                              <button
                                v-if="action.multiLanguage"
                                class="btn btn-gray"
                                title="Configurar idioma"
                                v-b-modal="`modal-multiple-translation-${index}`"
                                @click="
                                  openModalTranslation(
                                    action.email.additionalQuestions[index],
                                    i,
                                  )
                                "
                              >
                                <i style="color: #000" class="far fa-flag"></i>
                              </button>
                              <button
                                class="btn btn-outline-danger"
                                @click="removeMultipleChoice(index, i)"
                              >
                                <font-awesome-icon :icon="['fas', 'trash-alt']" />
                              </button>
                              <button
                                class="btn btn-outline-primary"
                                @click="addMultipleChoice(index)"
                              >
                                <font-awesome-icon :icon="['fas', 'plus']" />
                              </button>
                            </div>
                          </div>
                        </b-card-header>
                        <b-collapse
                          :id="`accordion-modal-${i}`"
                          :accordion="`my-accordion-modal-${i}`"
                          role="tabpanel"
                          visible
                        >
                          <b-card-body class="p-card-body">
                            <div v-if="loadingSubQuestions">
                              <b-spinner
                                variant="primary"
                                type="grow"
                                label="Loading..."
                              ></b-spinner>
                            </div>
                            <div v-else>
                              <draggable v-model="choice.subChoices" @change="updateOrderSubChoices(index, i, choice.subChoices)">
                              <div
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                "
                                v-for="(
                                  itemSubChoices, indexSubChoices
                                ) in choice.subChoices"
                                :key="indexSubChoices"
                              >
                              <font-awesome-icon :icon="['fas', 'ellipsis-v']" class="ellipsis-multiple" />
                                <input
                                  type="text"
                                  v-model="itemSubChoices.textPt"
                                  style="width: 85%"
                                />
                                <div class="m-sub-choice">
                                  <button
                                    v-if="action.multiLanguage"
                                    class="btn btn-gray"
                                    title="Configurar idioma"
                                    v-b-modal="
                                      `modal-sub-choices-translation-${index}-${indexSubChoices}`
                                    "
                                    @click="
                                      openModalTranslationSubChoices(
                                        action.email.additionalQuestions[index]
                                          .choices[i],
                                        indexSubChoices,
                                      )
                                    "
                                  >
                                    <i style="color: #000" class="far fa-flag"></i>
                                  </button>
                                  <button
                                    class="btn btn-outline-danger"
                                    @click="
                                      removeMultipleSubChoices(
                                        index,
                                        i,
                                        indexSubChoices,
                                      )
                                    "
                                  >
                                    <font-awesome-icon
                                      :icon="['fas', 'trash-alt']"
                                    />
                                  </button>
                                  <button
                                    class="btn btn-outline-primary"
                                    @click="addMultipleSubChoices(index, i)"
                                  >
                                    <font-awesome-icon :icon="['fas', 'plus']" />
                                  </button>
                                </div>
                              </div>
                              </draggable>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </template>
                </div>
              </draggable>
              <div class="row custom-switch mt-8">
                <div class="col-12" style="padding-left: 30px">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="switch-outros"
                    v-model="isCheckedOther"
                    v-on:change="toggleMultipleChoiceOther(index, $event)"
                  />
                  <label class="custom-control-label" for="switch-outros">{{
                    $t('newAction.stepOne.multipleChoiceModal.enableOther')
                  }}</label>
                </div>
                <div class="col-12 mt-2" style="padding-left: 30px">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="switch-random"
                    v-model="action.email.additionalQuestions[index].isRandomizeQuestionOrder"
                  />
                  <label class="custom-control-label" for="switch-random">Aleatorizar ordem</label>
                </div>
                <div class="col-12 mt-2" style="padding-left: 30px" v-if="action.email.additionalQuestions[index].template === 'withSubOptions'">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="switch-mandatory-suboption"
                    v-model="action.email.additionalQuestions[index].mandatorySubOption"
                  />
                  <label class="custom-control-label" for="switch-mandatory-suboption">Habilitar sub opção obrigatória</label>
                </div>
                <div v-if="action.email.additionalQuestions[index].multipleType === 'checkbox'" class="col-12 mt-2 display-flex" style="padding: 0">
                  <label class="mt-1" for="input-max-selection">Limitar seleção</label>
                  <b-form-input id="input-max-selection" min="1" type="number" class="limit-input" v-model="action.email.additionalQuestions[index].maximumAmountSelection"></b-form-input>
                </div>
                <div v-if="Number(action.email.additionalQuestions[index].maximumAmountSelection) === 0 && action.email.additionalQuestions[index].multipleType === 'checkbox'">
                  <p style="color: red;">Valor deve ser maior que 0</p>
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <!-- modal logical rules -->
        <b-modal
          :id="`modal-logical-rules-${index}`"
          :title="`${$t('actionTranslateUpdate.logicRules.modalTitle')}`"
          size="lg"
          ok-only
        >
          <div class="custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              :id="`logical-rule-${index}`"
              @click="item.logicalRuleEnabled = !item.logicalRuleEnabled"
              v-model="item.logicalRuleEnabled"
              @change="disabledDraggable(item.logicalRuleEnabled)"
            />
            <label class="custom-control-label" :for="`logical-rule-${index}`">
              {{ $t('actionTranslateUpdate.logicRules.description') }}</label
            >
          </div>
          <div class="container">
            <br />

            <p>{{ $t('actionTranslateUpdate.logicRules.conditionals') }}</p>
            <div class="col-12">
              <input
                type="text"
                class="form-control"
                :disabled="disabledQuestion"
                v-model="item.text"
              />
            </div>
            <p>{{ $t('actionTranslateUpdate.logicRules.is') }}</p>
            <div style="display: flex">
              <div class="col-6">
                <b-form-select
                  :disabled="!item.logicalRuleEnabled"
                  v-model="item.conditionalRule"
                  :options="returnOptionsRule(item.type)"
                  @change="disabledDraggable(item.logicalRuleEnabled)"
                ></b-form-select>
              </div>
              <div class="col-6">
                <b-form-select
                  :disabled="!item.logicalRuleEnabled"
                  v-model="item.conditionalValue"
                  :options="optionsValue"
                  @change="disabledDraggable(item.logicalRuleEnabled)"
                ></b-form-select>
              </div>
            </div>
            <br />
            <p>{{ $t('actionTranslateUpdate.logicRules.turnOff') }}</p>
            <div style="overflow-y: auto; height: 200px; margin-left: 10px">
              <div
                class="choice"
                v-for="(question, i) in getNextQuestions(index)"
                :key="i"
              >
                <template>
                  <input
                    :disabled="!item.logicalRuleEnabled"
                    style="zoom: 1.4"
                    type="checkbox"
                    :value="question.id"
                    :id="`logical-rules-checkbox-${index}-${i}`"
                    :name="`logical-rules-checkbox-${index}-${i}`"
                    :checked="
                      action.email.additionalQuestions[
                        index
                      ].idsDisabled.findIndex((el) => el === question.id) >= 0
                    "
                    @click="
                      handleQuestionClick(
                        $event,
                        question,
                        index,
                        item.logicalRuleEnabled,
                      )
                    "
                  />
                  <label :for="`logical-rules-checkbox-${index}-${i}`"
                    >{{ question.text }}
                  </label>
                </template>
              </div>
            </div>
          </div>
        </b-modal>

        <!-- modal translation -->
        <b-modal
          :id="`modal-translation-${index}`"
          title="Configurar tradução da pergunta adicional"
          size="lg"
          ok-only
        >
          <p>
            {{ $t('newAction.stepOne.labels.modalTranslationAddQuestion') }}
          </p>
          <div>
            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="br" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.portuguese') }}</label>
                </div>
                <div class="col col-lg-2">
                  <b-form-checkbox v-model="item.textCheckedPT">
                    <input
                      class="form-control size-input"
                      v-model="item.text"
                      style="margin-left: 10px"
                      @click="returnPlaceholder(item)"
                    />
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="us" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.english') }}</label>
                </div>
                <div class="col col-lg-2">
                  <b-form-checkbox v-model="item.textCheckedEN">
                    <input
                      class="form-control size-input"
                      v-model="item.textEN"
                      style="margin-left: 10px"
                      @click="returnPlaceholder(item)"
                    />
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="es" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.spanish') }}</label>
                </div>
                <div class="col col-lg-2">
                  <b-form-checkbox v-model="item.textCheckedES">
                    <input
                      class="form-control size-input"
                      v-model="item.textES"
                      style="margin-left: 10px"
                      @click="returnPlaceholder(item)"
                    />
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <!-- modal multiple choices translation-->
        <b-modal
          v-if="question"
          :id="`modal-multiple-translation-${index}`"
          title="Configurar tradução da pergunta adicional"
          size="lg"
          ok-only
        >
          <p>
            {{ $t('newAction.stepOne.labels.modalTranslationAddQuestion') }}
          </p>
          <div>
            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="br" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.portuguese') }}</label>
                </div>
                <div class="col col-lg-2">
                  <input
                    class="form-control size-input"
                    v-model="question.choices[indexChoice].text"
                    style="margin-left: 10px"
                  />
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="us" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.english') }}</label>
                </div>
                <div class="col col-lg-2">
                  <input
                    class="form-control size-input"
                    v-model="question.choices[indexChoice].textEN"
                    style="margin-left: 10px"
                  />
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="es" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.spanish') }}</label>
                </div>
                <div class="col col-lg-2">
                  <input
                    class="form-control size-input"
                    v-model="question.choices[indexChoice].textES"
                    style="margin-left: 10px"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-modal>

        <!-- modal multiple sub choices translation-->
        <b-modal
          v-if="subChoice"
          :id="`modal-sub-choices-translation-${index}-${indexSubChoice}`"
          title="Configurar tradução das sub opções"
          size="lg"
          ok-only
        >
          <p>
            {{ $t('newAction.stepOne.labels.modalTranslationAddQuestion') }}
          </p>
          <div>
            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="br" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.portuguese') }}</label>
                </div>
                <div class="col col-lg-2">
                  <input
                    class="form-control size-input"
                    v-model="subChoice.subChoices[indexSubChoice].textPt"
                    style="margin-left: 10px"
                  />
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="us" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.english') }}</label>
                </div>
                <div class="col col-lg-2">
                  <input
                    class="form-control size-input"
                    v-model="subChoice.subChoices[indexSubChoice].textEn"
                    style="margin-left: 10px"
                  />
                </div>
              </div>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-2" style="padding: 0">
                  <country-flag country="es" size="normal" />
                  <label>{{ $t('newAction.stepOne.labels.spanish') }}</label>
                </div>
                <div class="col col-lg-2">
                  <input
                    class="form-control size-input"
                    v-model="subChoice.subChoices[indexSubChoice].textEs"
                    style="margin-left: 10px"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>
    </draggable>
    <b-form-radio-group
      v-if="active && action.channel !== 'widget'"
      v-model="action.addQuestionTemplate"
    >
      <label class="font-weight-bold">{{
        $t('newAction.stepOne.questionFormatting')
      }}</label>
      <div class="ml-3">
        <b-form-radio class="row mr-4" value="default">
          {{ $t('newAction.stepOne.default') }}
          <font-awesome-icon
            id="template-default"
            :icon="['fas', 'info-circle']"
            style="font-size: 15px; color: #c1c1c1"
          />
        </b-form-radio>
        <b-form-radio class="row" value="custom">
          <span>
            {{ $t('newAction.stepOne.custom') }}
          </span>
          <font-awesome-icon
            id="template-custom"
            :icon="['fas', 'info-circle']"
            style="font-size: 15px; color: #c1c1c1"
          />
        </b-form-radio>
      </div>

      <b-popover target="template-custom" triggers="hover" placement="top">
        {{ $t('newAction.stepOne.customDescription') }}
      </b-popover>

      <b-popover target="template-default" triggers="hover" placement="top">
        {{ $t('newAction.stepOne.defaultDescription') }}
      </b-popover>
    </b-form-radio-group>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag';
import draggable from 'vuedraggable';
import swal from 'sweetalert';
import { mapState } from 'vuex';
import cSat from '@/components/molecules/metrics/csat';
import nps from '@/components/molecules/metrics/nps';
import likert from '@/components/molecules/metrics/likert';
import api from '../../../services/api';

export default {
  name: 'AddQuestions',

  components: {
    draggable,
    CountryFlag,
    cSat,
    nps,
    likert,
  },

  data: () => ({
    isGNDI: false,
    active: false,
    displayChoices: true,
    contactCheckbox: [],
    selected: [],
    options: [
      { text: 'Nome', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Telefone', value: 'phone' },
    ],
    optionsProfile: [
      { text: '10-9', value: 'promotor' },
      { text: '8-7', value: 'neutro' },
      { text: '6-0', value: 'detrator' },
    ],
    selectedDisplayType: '',
    optionsIndicator: [],
    optionsCriterion: [
      { text: 'Igual a', value: 'equal' },
      { text: 'Diferente de', value: 'different' },
      { text: 'Contém', value: 'contains' },
    ],
    optionsRules: [
      { text: 'Selecione uma regra', value: null },
      { text: 'Igual a', value: 'equal' },
      { text: 'Maior que', value: 'biggerThen' },
      { text: 'Maior ou igual a', value: 'greaterOrEqualTo' },
      { text: 'Menor que', value: 'lessThan' },
      { text: 'Menor ou igual a', value: 'lessThanOrEqualTo' },
      { text: 'Diferente de', value: 'differentThan' },
    ],
    optionsRulesMultiple: [
      { text: 'Selecione uma regra', value: null },
      { text: 'Igual a', value: 'equal' },
      { text: 'Diferente de', value: 'differentThan' },
    ],
    optionsLikeEmotion: [
      { text: 'Selecione uma regra', value: null },
      { text: 'Igual a', value: 'equal' },
    ],
    optionsValue: [],
    checked: false,
    draggable: false,
    disabledQuestion: true,
    isCheckedOther: false,
    isRandomizeQuestionOrder: false,
    indexChoice: 0,
    question: null,
    optionsTemplateLikert: [
      { text: 'Satisfação', value: 'satisfaction' },
      { text: 'Concordância', value: 'agreement' },
      { text: 'Frequência', value: 'frequency' },
      { text: 'Importância', value: 'importance' },
      { text: 'Probabilidade', value: 'probability' },
    ],
    likertTemplate: 'satisfaction',
    exampleListMultiples: [
      {
        choices: [
          {
            text: 'Opção 1 - Setores',
            subChoices: ['SAC', 'Informatica'],
            selected: [],
          },
          {
            text: 'Opção 2 - Categoria',
            subChoices: ['Limpeza', 'Administração', 'Gestão'],
            selected: [],
          },
        ],
      },
    ],
    loadingSubQuestions: false,
    indexSubChoice: 0,
    subChoice: null,
    selectedRadioChoice: { text: null },
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.isGNDI =
      this.userAuth.companyId === '6026720a451b70498739d07f' ||
      this.userAuth.companyId === '5d8ba15696fa442270173557'
        ? true
        : false;
  },

  async mounted() {
    // get action indicators
    await this.getActionIndicators();

    if (
      this.action.email.additionalQuestions.some(
        (elem) => elem.logicalRuleEnabled === true,
      )
    ) {
      this.draggable = true;
    }

    if (
      this.action.email.additionalQuestions.some(
        (elem) => elem.idsDisabled.length > 0,
      )
    ) {
      this.draggable = true;
    }

    if (this.action.type.includes('1-5') || this.action.type === '5-stars') {
      this.optionsProfile = [
        { text: '5-4', value: 'promotor' },
        { text: '3', value: 'neutro' },
        { text: '2-1', value: 'detrator' },
      ];
    } else if (this.action.type === 'like-dislike') {
      this.optionsProfile = [
        { text: 'Like', value: 'promotor' },
        { text: 'Dislike', value: 'detrator' },
      ];
    }

    if (this.action.type === 'like-dislike') {
      this.optionsProfile = [
        { text: 'Like', value: 'promotor' },
        { text: 'Dislike', value: 'detrator' },
      ];
    }

    if (this.action.email.additionalQuestions.length > 0) {
      this.active = true;

      for (
        let i = 0;
        i < this.action.email.additionalQuestions.length;
        i += 1
      ) {
        if (this.action.email.additionalQuestions[i].type === 'CONTACT') {
          if (
            this.action.email.additionalQuestions[i].displayType ===
            'formSearch'
          ) {
            this.selectedDisplayType = 'formSearch';
          } else {
            this.selectedDisplayType = 'afterSendAnswer';
          }

          for (
            let j = 0;
            j < this.action.email.additionalQuestions[i].choices.length;
            j += 1
          ) {
            if (
              this.action.email.additionalQuestions[i].choices[j].includes(
                'name',
              )
            ) {
              this.selected.push('name');
            }

            if (
              this.action.email.additionalQuestions[i].choices[j].includes(
                'email',
              )
            ) {
              this.selected.push('email');
            }

            if (
              this.action.email.additionalQuestions[i].choices[j].includes(
                'phone',
              )
            ) {
              this.selected.push('phone');
            }
          }
        }
      }
    }
  },

  computed: {
    ...mapState('actions', ['action']),
  },

  methods: {
    updateOrderChoices(index, choices){
      this.displayChoices = false;
      this.action.email.additionalQuestions[index].choices = choices;
      this.displayChoices = true;
    },

    updateOrderSubChoices(index, indexChoice, subChoices){
      this.loadingSubQuestions = true;
      this.action.email.additionalQuestions[index].choices[indexChoice].subChoices = subChoices;
      this.loadingSubQuestions = false;
    },

    removeMultipleSubChoices(indexAddQuestion, indexChoice, indexSubChoices) {
      this.loadingSubQuestions = true;
      this.action.email.additionalQuestions[indexAddQuestion].choices[
        indexChoice
      ].subChoices.splice(indexSubChoices, 1);

      this.loadingSubQuestions = false;
    },

    addMultipleSubChoices(indexAddQuestion, indexChoice) {
      this.loadingSubQuestions = true;
      const size =
        this.action.email.additionalQuestions[indexAddQuestion].choices[
          indexChoice
        ].subChoices.length;

      this.action.email.additionalQuestions[indexAddQuestion].choices[
        indexChoice
      ].subChoices.push({
        textPt: `${`Sub Opção ${size + 1}`}`,
        id: Math.random().toString(36).substr(2, 10),
      });
      this.loadingSubQuestions = false;
    },

    showSubQuestion(indexAddQuestion, indexChoice) {
      this.loadingSubQuestions = true;
      const hideQuestion = document.getElementById(
        `sub-options-${indexChoice}`,
      );
      hideQuestion.style.display = 'none';

      const showSubQuestion = document.getElementById(
        `sub-options-accordion-${indexChoice}`,
      );
      showSubQuestion.style.display = 'block';

      const existSubChoices =
        this.action.email.additionalQuestions[indexAddQuestion].choices[
          indexChoice
        ].subChoices;

      if (!existSubChoices || existSubChoices.length === 0) {
        this.action.email.additionalQuestions[indexAddQuestion].choices[
          indexChoice
        ].subChoices = [];

        this.action.email.additionalQuestions[indexAddQuestion].choices[
          indexChoice
        ].subChoices.push({
          textPt: 'Sub Opção 1',
          id: Math.random().toString(36).substr(2, 10),
        });
      }

      this.loadingSubQuestions = false;
    },

    openModalTranslationSubChoices(subQuestion, indexSubChoice) {
      this.indexSubChoice = indexSubChoice;
      this.subChoice = subQuestion;
    },

    openModalTranslation(addQuestion, indexChoice) {
      this.indexChoice = indexChoice;
      this.question = addQuestion;
    },

    setCheckedOther(index) {
      const existOther = this.action.email.additionalQuestions[
        index
      ].choices.filter((item) => item.isOther);
      if (existOther.length) {
        this.isCheckedOther = true;
      } else {
        this.isCheckedOther = false;
      }
    },
    returnPlaceholder(question) {
      if (question.text && question.textCheckedPT) {
        return question.text;
      } else if (question.textES && question.textCheckedES) {
        return question.textES;
      } else if (question.textEN && question.textCheckedEN) {
        return question.textEN;
      }
      return '';
    },

    disabledDraggable(logicalRuleEnabled) {
      if (logicalRuleEnabled) {
        if (
          this.action.email.additionalQuestions.some(
            (elem) => elem.logicalRuleEnabled === true,
          )
        ) {
          this.draggable = true;
        }

        if (
          this.action.email.additionalQuestions.some(
            (elem) => elem.idsDisabled.length > 0,
          )
        ) {
          this.draggable = true;
        }
      } else {
        this.draggable = false;
      }
    },

    handleQuestionClick(
      event,
      question,
      indexQuestionConfig,
      logicalRuleEnabled,
    ) {
      if (event.target.checked === true) {
        this.action.email.additionalQuestions[
          indexQuestionConfig
        ].idsDisabled.push(question.id);
      } else {
        const indexQuestion = this.action.email.additionalQuestions[
          indexQuestionConfig
        ].idsDisabled.indexOf(question.id);

        if (indexQuestion > -1) {
          this.action.email.additionalQuestions[
            indexQuestionConfig
          ].idsDisabled.splice(indexQuestion, 1);
        }
      }

      this.disabledDraggable(logicalRuleEnabled);
    },

    returnOptionsRule(typeAddQuestion) {
      if (typeAddQuestion === 'MULTIPLE') {
        return this.optionsRulesMultiple;
      } else if (
        typeAddQuestion === 'EMOTION' ||
        typeAddQuestion === 'LIKE/DISLIKE'
      ) {
        return this.optionsLikeEmotion;
      }
      return this.optionsRules;
    },

    getNextQuestions(index) {
      const indexQuestionModal = this.action.email.additionalQuestions.indexOf(
        this.action.email.additionalQuestions[index],
        index,
      );

      const newArrayQuestions = [];

      for (
        let i = 0;
        i < this.action.email.additionalQuestions.length;
        i += 1
      ) {
        if (
          this.action.email.additionalQuestions[i].type !== 'CONTACT' ||
          (this.action.email.additionalQuestions[i].type === 'CONTACT' &&
            this.action.email.additionalQuestions[i].displayType ===
              'formSearch')
        ) {
          const indexQuestion = this.action.email.additionalQuestions.indexOf(
            this.action.email.additionalQuestions[i],
          );

          if (indexQuestion > indexQuestionModal) {
            newArrayQuestions.push(this.action.email.additionalQuestions[i]);
          }
        }
      }

      return newArrayQuestions;
    },

    returnValue(typeQuestion, index) {
      if (typeQuestion === 'REVIEWS') {
        this.optionsValue = [
          { text: 'Selecione o valor', value: null },
          { text: '1 estrela', value: 1 },
          { text: '2 estrelas', value: 2 },
          { text: '3 estrelas', value: 3 },
          { text: '4 estrelas', value: 4 },
          { text: '5 estrelas', value: 5 },
        ];
      } else if (typeQuestion === 'CSAT' || typeQuestion === 'NPS') {
        this.optionsValue = [
          { text: 'Selecione o valor', value: null },
          { text: '0', value: 0 },
          { text: '1', value: 1 },
          { text: '2', value: 2 },
          { text: '3', value: 3 },
          { text: '4', value: 4 },
          { text: '5', value: 5 },
          { text: '6', value: 6 },
          { text: '7', value: 7 },
          { text: '8', value: 8 },
          { text: '9', value: 9 },
          { text: '10', value: 10 },
        ];
      } else if (typeQuestion === 'LIKE/DISLIKE') {
        this.optionsValue = [
          { text: 'Selecione o valor', value: null },
          { text: 'Dislike (Negativo)', value: 0 },
          { text: 'Like (Positivo)', value: 1 },
        ];
      } else if (typeQuestion === 'EMOTION') {
        this.optionsValue = [
          { text: 'Selecione o valor', value: null },
          { text: 'Carinha triste', value: 0 },
          { text: 'Carinha feliz', value: 1 },
        ];
      } else if (typeQuestion === 'CES') {
        this.optionsValue = [
          { text: 'Selecione o valor', value: null },
          { text: '1', value: 1 },
          { text: '2', value: 2 },
          { text: '3', value: 3 },
          { text: '4', value: 4 },
          { text: '5', value: 5 },
        ];
      } else if (
        typeQuestion === 'LIKERT' ||
        typeQuestion === 'LIKERT/EMOTION'
      ) {
        this.optionsValue = [
          { text: 'Selecione o valor', value: null },
          { text: 'Muito Satisfeito', value: 5 },
          { text: 'Satisfeito', value: 4 },
          { text: 'Indiferente', value: 3 },
          { text: 'Insatisfeito', value: 2 },
          { text: 'Muito Insatisfeito', value: 1 },
        ];
      } else if (typeQuestion === 'MULTIPLE') {
        const arrayMultipleChoices = [
          {
            text: 'Selecione uma resposta',
            value: null,
          },
        ];

        for (
          let i = 0;
          i < this.action.email.additionalQuestions[index].choices.length;
          i += 1
        ) {
          arrayMultipleChoices.push({
            text: this.action.email.additionalQuestions[index].choices[i].text,
            value: this.action.email.additionalQuestions[index].choices[i].text,
          });
        }

        this.optionsValue = arrayMultipleChoices;
      }

      return this.optionsValue;
    },

    changeExhibition(value, index) {
      if (value === 'formSearch') {
        this.action.email.additionalQuestions[index].displayType = value;
      } else {
        this.action.email.additionalQuestions[index].displayType = value;
      }
    },

    addQuestion() {
      if (this.action.email.additionalQuestions.length > 255) {
        return;
      }

      this.action.email.additionalQuestions.push({
        type: 'REVIEWS',
        text: '',
        commentEnabled: false,
        applicableEnabled: false,
        profileEnabled: false,
        selectedProfile: null,
        indicatorValueEnabled: false,
        selectedIndicator: null,
        indicatorValue: null,
        indicatorCriterion: null,
        logicalRuleEnabled: false,
        conditionalRule: null,
        conditionalValue: null,
        mandatory: false,
        idsDisabled: [],
        id: Math.random().toString(36).substr(2, 10),
        group: 0,
        display: false,
      });
    },

    removeQuestion(index) {
      const question = this.action.email.additionalQuestions[index];
      const allQuestions = this.action.email.additionalQuestions;
      let deleteQuestion = false;

      if (question.logicalRuleEnabled && question.idsDisabled.length > 0) {
        swal({
          title: 'Atenção!',
          text: 'A regra lógica desta pergunta esta configurada, desconfigure para poder excluir.',
          icon: 'warning',
        });

        deleteQuestion = false;
      } else {
        const linkedQuestions = [];
        let isLinked = false;

        for (let i = 0; i < allQuestions.length; i += 1) {
          if (allQuestions[i].idsDisabled.includes(question.id)) {
            linkedQuestions.push(allQuestions[i].text);
            isLinked = true;
          }
        }

        if (isLinked && !question.logicalRuleEnabled) {
          swal({
            title: 'Atenção!',
            text: `Esta pergunta esta vinculada a regra lógica de: ${linkedQuestions}. Desabilite para poder excluir.`,
            icon: 'warning',
          });
        } else {
          deleteQuestion = true;
        }
      }

      if (deleteQuestion) {
        this.action.email.additionalQuestions.splice(index, 1);
        if (this.action.email.additionalQuestions.length === 0) {
          this.active = false;
        }
      }
    },

    verifyQuestionType(type, index) {
      if (type === 'MULTIPLE') {
        this.action.email.additionalQuestions[index].multipleType = 'radio';
        this.action.email.additionalQuestions[index].choices = [
          {
            text: this.$t('newAction.stepOne.multipleChoiceModal.newOption', {
              option: 1,
            }),
            id: Math.random().toString(36).substr(2, 10),
          },
          {
            text: this.$t('newAction.stepOne.multipleChoiceModal.newOption', {
              option: 2,
            }),
            id: Math.random().toString(36).substr(2, 10),
          },
          {
            text: this.$t('newAction.stepOne.multipleChoiceModal.newOption', {
              option: 3,
            }),
            id: Math.random().toString(36).substr(2, 10),
          },
          {
            text: this.$t('newAction.stepOne.multipleChoiceModal.newOption', {
              option: 4,
            }),
            id: Math.random().toString(36).substr(2, 10),
          },
        ];
      } else if (type === 'CONTACT') {
        this.action.email.additionalQuestions[index].displayType = 'formSearch';
        this.action.email.additionalQuestions[index].choices = [];
      } else {
        delete this.action.email.additionalQuestions[index].multipleType;
        delete this.action.email.additionalQuestions[index].choices;
      }
    },

    addMultipleChoice(addQuestionIndex) {
      this.displayChoices = false;
      const size =
        this.action.email.additionalQuestions[addQuestionIndex].choices.length +
        1;

      this.action.email.additionalQuestions[addQuestionIndex].choices.push({
        text: this.$t('newAction.stepOne.multipleChoiceModal.newOption', {
          option: size,
        }),
        id: Math.random().toString(36).substr(2, 10), // id added for conditional rule
      });
      this.displayChoices = true;
    },

    removeMultipleChoice(addQuestionIndex, choiceIndex) {
      this.displayChoices = false;
      if (
        this.action.email.additionalQuestions[addQuestionIndex].choices.length >
        1
      ) {
        this.action.email.additionalQuestions[addQuestionIndex].choices.splice(
          choiceIndex,
          1,
        );
      }
      this.displayChoices = true;
    },

    toggleMultipleChoiceOther(addQuestionIndex, event) {
      const otherIndex = this.action.email.additionalQuestions[
        addQuestionIndex
      ].choices.findIndex((item) => item.isOther === true);

      if (event.target.checked) {
        if (otherIndex === -1) {
          this.action.email.additionalQuestions[addQuestionIndex].choices.push({
            text: this.$t('newAction.stepOne.multipleChoiceModal.other'),
            isOther: true,
          });
        }
      } else if (otherIndex !== -1) {
        this.action.email.additionalQuestions[addQuestionIndex].choices.splice(
          otherIndex,
          1,
        );
      }
    },

    handleMultipleType(type, index) {
      this.displayChoices = false;
      this.action.email.additionalQuestions[index].multipleType = type;
      this.displayChoices = true;
    },

    inputChecked(fields, addQuestionIndex) {
      this.action.email.additionalQuestions[addQuestionIndex].choices = fields;
    },

    async getActionIndicators() {
      const response = await api.get(`indicator/${this.action._id}`, {
        headers: { 'x-access-token': this.userAuth.token },
      });
      this.optionsIndicator = [];
      if (response.data) {
        for (let i = 0; i < response.data.length; i += 1) {
          this.optionsIndicator.push({
            value: response.data[i].key,
            text: response.data[i].name,
          });
        }
      }
    },
  },

  watch: {
     active: function watchActive(value) {
      if (value && this.action.email.additionalQuestions.length === 0) {
        this.action.email.additionalQuestions.push({
          type: 'REVIEWS',
          text: '',
          commentEnabled: false,
          applicableEnabled: false,
          profileEnabled: false,
          selectedProfile: null,
          indicatorValueEnabled: false,
          selectedIndicator: null,
          indicatorValue: null,
          logicalRuleEnabled: false,
          conditionalRule: null,
          conditionalValue: null,
          idsDisabled: [],
          id: Math.random().toString(36).substr(2, 10),
          group: 0,
          display: false,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.limit-input {
  width: 80px;
  margin-left: 12px;
}

.ellipsis-multiple {
  margin-top: 12px;
  margin-right: 12px;
  color: #c1c1c1;
}

.arrow-toggle {
  position: absolute;
  left: -40px;
  top: 0;
}

.example {
  height: 132px;
  width: 210px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  padding: 12px;
}

.m-sub-choice {
  margin-right: 5px;
  margin-top: 5px;
}

.display-flex {
  display: flex;
}
.p-card-body {
  padding: 0 0 0 32px;
}

.card-accordion-multiple {
  background: #fff;
  border: none;
}

.example-multiple-choices {
  width: 250px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  margin-left: 20px;
}

.btn-arrow {
  background: #fff;
  background: #fff;
  border: none;
  margin-left: -10px;
}

.icon-arrow-right {
  color: #5e5e5e;
  margin-top: 7px;
  width: 15px;
}

.custom-radio input {
  display: none;
}

.custom-radio input + label:before {
  content: '';
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: white;
  border: 1px solid #bababa;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
  margin-bottom: 3px;
}

.custom-radio input:checked + label:before {
  background-color: white;
  box-sizing: border-box;
  border: 5px solid #4ce595;
  padding: 1px;
}

.btn-gray {
  display: inline-block;
  font-weight: 400;
  color: #55545480;
  background-color: transparent;
  border: 1px solid #55545480;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.title {
  font-weight: bold;
  font-size: 15px;
}

.checkbox-contact {
  padding-top: 10px;
  padding-bottom: 10px;
}

.switch-area label {
  margin-bottom: 0;
}

.custom-switch {
  display: inline;
}

.comment-enabled {
  color: $primary;
}

.item-question {
  cursor: move;
  display: flex;
  flex-direction: row;

  & > * {
    margin-right: 8px;
    max-height: 40px;
  }

  &:last-child {
    margin-right: 0;
  }

  .question-text {
    flex-grow: 1;
  }
}

.ellipsis {
  margin-top: 10px;
  color: #c1c1c1;
}

.metric-icons {
  color: $gray;
}

.choice {
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;

  & > * {
    margin-right: 8px;
  }

  .choice-text {
    flex-grow: 1;
  }

  input {
    background: transparent;
    border: 0;

    &:focus {
      outline: none;
      border-bottom: 1px solid $gray;
    }
  }
}

.likert-options {
  margin-top: -28px;
}
</style>

<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
    max-width: 822px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/additional-question/index.vue